import React, { useState } from "react";
import { observer } from "mobx-react";
import { useStore } from "../../../store";
import {
  SelectChangeEvent,
  Dialog,
  DialogActions,
  DialogContent,
  Button,
} from "@mui/material";
import Select, { SelectProps } from "../../../components/Select";
import SelectRationg, {
  SelectRatingProps,
} from "../../../components/SelectRating";
import Search, { SearchProps } from "../../../components/Search";
import { TextField, Autocomplete } from "@mui/material";
import { Container, Box, Typography } from "../styles";
import { getLanguageCode, defaultAllCode } from "../LanguageCode";
import DateRangePicker from "../../../components/DateRangePicker";
import { defaultAllCategory, getCategoryCode } from "../CategoryCode";
import dayjs from "dayjs";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { useCookies, Cookies } from "react-cookie";
import moment from "moment";

const Handler = () => {
  const {
    ModerationStore: {
      application,
      setApplication,
      nowDate,
      status,
      setStatus,
      startDate,
      setStartDate,
      endDate,
      setEndDate,
      searchText,
      setSearchText,
      searchOption,
      setSearchOption,
      setLanguageChange,
      language,
      searchHandler,
      category,
      setCategoryChange,
      mixability,
      setMixability,
      reference,
      setReference,
      asset,
      setAsset,
      entertainment,
      setEntertainment,
      setRows,
      gridOption: { page, rowsPerPage },
    },
  } = useStore();

  const [btnOpen, setBtnOpen] = useState(false);

  const [cookies, setCookie, removeCookie] = useCookies();
  const expires = moment().add("100", "y").toDate();
  const gGookies = new Cookies();
  const getCookie = (item: string) => {
    return gGookies.get(item);
  };

  const selectProps: SelectProps = {
    width: 122,
    name: "Status",
    value: status,
    selectHandler: (event: SelectChangeEvent<any>) => {
      setStatus(event.target.value);
    },
    defaultValue: "InReview",
    list: [
      { label: "Preparing", value: "Preparing" },
      { label: "In Review", value: "InReview" },
      { label: "Rejected", value: "Rejected" },
      { label: "Published", value: "Published" },
      { label: "All", value: "All" },
    ],
  };

  const selectApplicationProps: SelectProps = {
    width: 122,
    name: "Application",
    value: application,
    selectHandler: (event: SelectChangeEvent<any>) => {
      setApplication(event.target.value);
    },
    defaultValue: "all",
    list: [
      { label: "All", value: "all" },
      { label: "KineMaster", value: "kinemaster" },
      { label: "Spring", value: "spring" },
    ],
  };

  const selectMixabilityProps: SelectRatingProps = {
    width: 180,
    name: "Mixability",
    value: mixability,
    defaultValue: 1,
    selectHandler: (event: SelectChangeEvent<any>) => {
      setMixability(event.target.value);
    },
  };

  const selectReferenceProps: SelectRatingProps = {
    width: 180,
    name: "Reference",
    value: reference,
    defaultValue: 1,
    selectHandler: (event: SelectChangeEvent<any>) => {
      setReference(event.target.value);
    },
  };

  const selectAssetProps: SelectRatingProps = {
    width: 180,
    name: "Asset",
    value: asset,
    defaultValue: 1,
    selectHandler: (event: SelectChangeEvent<any>) => {
      setAsset(event.target.value);
    },
  };

  const selectEntertainmentProps: SelectRatingProps = {
    width: 180,
    name: "Entertainment",
    value: entertainment,
    defaultValue: 1,
    selectHandler: (event: SelectChangeEvent<any>) => {
      setEntertainment(event.target.value);
    },
  };

  const rangeDateProps = {
    startDate,
    endDate,
    setStartDate,
    setEndDate,
  };
  const onKeyPressEnter = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      searchHandler();
    }
  };

  const searchProps: SearchProps = {
    option: {
      value: searchOption,
      selectHandler: (event: SelectChangeEvent<any>) => {
        setSearchOption(event.target.value);
        setSearchText("");
      },
      defaultValue: "templateId",
      list: [
        { label: "Template ID", value: "templateId" },
        { label: "Description", value: "description" },
        { label: "User ID", value: "userId" },
        { label: "User Name", value: "username" },
        { label: "User Nickname", value: "name" },
        { label: "Reviewer", value: "reviewer" },
        { label: "Rejected Reason", value: "rejectedReason" },
        { label: "Extra Description", value: "extraDescription" },
        { label: "Score", value: "score" },
        { label: "Dynamic Link", value: "dynamicLink" },
      ],
    },
    value: searchText,
    textHandler: (event: React.ChangeEvent<HTMLInputElement>) => {
      setSearchText(event.target.value);
    },
    removeHandler: () => {
      setSearchText("");
    },
    action: () => {
      searchHandler();
    },
    keyHandler: (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === "Enter") searchHandler();
    },
  };
  const onChangeLang = (event: any, value: any) => {
    if (value) {
      // setAutoLangCode(value);

      setLanguageChange(value);
    }
  };

  const onChangeCategory = (event: any, value: any) => {
    if (value) {
      setCategoryChange(value);
    }
  };

  const handleButton = () => {
    setCookie("page", page, { path: "/", expires });
    setCookie("rowsPerPage", rowsPerPage, { path: "/", expires });
    setCookie("startDate", startDate, { path: "/", expires });
    setCookie("endDate", endDate, { path: "/", expires });
    setCookie("application", application, { path: "/", expires });
    setCookie("status", status, { path: "/", expires });
    setCookie("language", JSON.stringify(language), { path: "/", expires });
    setCookie("category", JSON.stringify(category), { path: "/", expires });

    setRows();
    setBtnOpen(false);
  };

  const handleClose = () => {
    setApplication(getCookie("application") ? getCookie("application") : "all");
    setStatus(getCookie("status") ? getCookie("status") : "InReview");

    setStartDate(
      window.location.pathname.includes("userid")
        ? dayjs("2023/01/01", "yyyy/MM/dd")
        : getCookie("startDate")
        ? getCookie("startDate")
        : dayjs().subtract(1, "month").toDate()
    );
    setEndDate(
      window.location.pathname.includes("userid")
        ? dayjs().toDate()
        : getCookie("endDate")
        ? dayjs(getCookie("endDate"), "yyyy/MM/dd").toDate()
        : dayjs().toDate()
    );

    setLanguageChange(
      getCookie("language") ? getCookie("language") : defaultAllCode
    );
    setCategoryChange(
      getCookie("category") ? getCookie("category") : defaultAllCategory
    );

    setBtnOpen(false);
  };

  return (
    <>
      <Container>
        <FilterAltIcon
          onClick={() => {
            setBtnOpen(true);
          }}
          sx={{ cursor: "pointer", color: "#6750a4" }}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "row", // 수평 정렬
            alignItems: "center", // 세로 중앙 정렬
            justifyContent: "flex-start", // 수평 왼쪽 정렬
            width: "100%", // 가로 너비 100%
            flexWrap: "wrap", // 필요한 경우 줄바꿈
            gap: 1, // 요소 사이 간격
          }}
        >
          <Typography sx={{ color: "#79747E" }}>Application</Typography>
          <Typography sx={{ width: "7%" }}>
            {application === "kinemaster"
              ? "KineMaster"
              : application === "spring"
              ? "Spring"
              : "All"}
          </Typography>
          <Typography sx={{ color: "#79747E" }}>Status</Typography>
          <Typography sx={{ width: "7%" }}>{status}</Typography>
          <Typography sx={{ color: "#79747E" }}>Date</Typography>
          <Typography sx={{ width: "15%" }}>
            {dayjs(startDate).format("YYYY-MM-DD") +
              " ~ " +
              dayjs(endDate).format("YYYY-MM-DD")}
          </Typography>
          <Typography sx={{ fontSize: "15px", color: "#79747E" }}>
            Language
          </Typography>
          <Typography
            sx={{
              width: "10%",
              maxWidth: "18%",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            {" "}
            {language.name}
          </Typography>
          <Typography sx={{ fontSize: "15px", color: "#79747E" }}>
            Category{" "}
          </Typography>
          <Typography
            sx={{
              pr: 5,
              width: "8%",
              maxWidth: "100px", // 최대 너비를 설정하여 말줄임 효과를 확인할 수 있도록 함
              whiteSpace: "nowrap",
            }}
          >
            {" "}
            {category.key}
          </Typography>
        </Box>
        <Box>
          <Search {...searchProps} />
        </Box>
      </Container>
      <Dialog
        disableEscapeKeyDown
        open={btnOpen}
        onClose={handleClose}
        sx={{
          "& .MuiDialog-paper": {
            maxWidth: "900px",
            minWidth: "900px",
            maxHeight: "550px",
            minHeight: "550px",
          },
        }}
      >
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <Box>
            <Select {...selectApplicationProps} />
            <Select {...selectProps} />

            <Autocomplete
              disablePortal
              size="small"
              id="combo-box-demo"
              value={language}
              options={[defaultAllCode].concat(getLanguageCode)}
              onChange={onChangeLang}
              onKeyPress={onKeyPressEnter}
              getOptionLabel={(option: any) => {
                if (option.name === "All") {
                  return `All`;
                } else {
                  return `${option.name} (${option.value})`;
                }
              }}
              renderInput={(params) => {
                return <TextField {...params} label="Language" />;
              }}
              isOptionEqualToValue={(option: any, value: any) =>
                option.name === value.name && option.value === value.value
              }
              sx={{
                "& .MuiFormControl-root.MuiTextField-root": {
                  width: 390,
                },
              }}
            />
            <Autocomplete
              disablePortal
              size="small"
              id="combo-box-demo"
              value={category}
              options={[defaultAllCategory].concat(getCategoryCode)}
              onChange={onChangeCategory}
              onKeyPress={onKeyPressEnter}
              getOptionLabel={(option: any) => {
                if (option.key === "All") {
                  return `All`;
                } else {
                  return `${option.key}`;
                }
              }}
              renderInput={(params) => {
                return <TextField {...params} label="Category" />;
              }}
              isOptionEqualToValue={(option: any, value: any) =>
                option.key === value.key
              }
              sx={{
                "& .MuiFormControl-root.MuiTextField-root": {
                  width: 180,
                },
              }}
            />
          </Box>
          <DialogContent
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              pl: 0,
              pt: 1,
            }}
          >
            <DateRangePicker {...rangeDateProps}></DateRangePicker>
          </DialogContent>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleButton}>OK</Button>
        </DialogActions>
      </Dialog>

      {searchOption === "score" && (
        <Container>
          <Box>
            <SelectRationg {...selectMixabilityProps} />
            <SelectRationg {...selectReferenceProps} />
            <SelectRationg {...selectAssetProps} />
            <SelectRationg {...selectEntertainmentProps} />
          </Box>
        </Container>
      )}
    </>
  );
};

export default observer(Handler);
